export default __webpack_public_path__ + "static/LemonCookieinCircle-f91aa957773ce1d9750fafbdb84ab034.png";